import { __assign, __rest } from "tslib";
import React from 'react';
import InternalStatusIndicator from './internal';
import { useTelemetry } from '../internal/hooks/use-telemetry';
export default function StatusIndicator(_a) {
    var _b = _a.type, type = _b === void 0 ? 'success' : _b, rest = __rest(_a, ["type"]);
    useTelemetry('StatusIndicator');
    return React.createElement(InternalStatusIndicator, __assign({ type: type }, rest));
}
//# sourceMappingURL=index.js.map